import { useState, useCallback, useEffect } from 'react';
import { useNotification } from '../contexts/notification-context';
import { httpGetTicketStatus } from '../api/ListsAPI';

interface returnType {
  list: { id: string; name: string }[];
}

export default function useTicketStatusList(): returnType {
  // notifications handler
  const { setNotification } = useNotification();

  const [list, setList] = useState([]);

  const getStatus = useCallback(() => {
    httpGetTicketStatus()
      .then(({ data }) => {
        if (data.success) {
          const wildCardId = data.ticketStatus.length + 1;
          data.ticketStatus.unshift({ id: wildCardId, name: 'Show all' });
          setList(data.ticketStatus);
        }
      })
      .catch(({ response }) => {
        setNotification({
          type: 'error',
          message: response.data.msg,
          open: true,
        });
      });
  }, [setNotification]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  return { list };
}